import { useMemo } from 'react';
import { FileCode, FileText, Combine } from 'lucide-react';
import type { DetectedFormat } from '../types';

interface StatusBarProps {
  source: string;
  format: DetectedFormat;
}

const FORMAT_CONFIG = {
  md: { icon: FileText, label: 'Markdown', color: 'text-blue-600' },
  html: { icon: FileCode, label: 'HTML', color: 'text-orange-600' },
  hybrid: { icon: Combine, label: 'Hybrid', color: 'text-purple-600' },
} as const;

export function StatusBar({ source, format }: StatusBarProps) {
  const stats = useMemo(() => {
    const chars = source.length;
    const words = source.trim() ? source.trim().split(/\s+/).length : 0;
    const lines = source.split('\n').length;
    return { chars, words, lines };
  }, [source]);

  const formatInfo = FORMAT_CONFIG[format];
  const Icon = formatInfo.icon;

  return (
    <div className="flex items-center justify-between px-4 py-2 bg-[#e8e8ed] border-t border-gray-300 text-xs text-gray-600">
      <div className="flex items-center gap-4">
        <div className={`flex items-center gap-1.5 font-medium ${formatInfo.color}`}>
          <Icon className="w-3.5 h-3.5" />
          <span>{formatInfo.label}</span>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <span>{stats.chars.toLocaleString()} chars</span>
        <span>{stats.words.toLocaleString()} words</span>
        <span>{stats.lines.toLocaleString()} lines</span>
      </div>
    </div>
  );
}
